// modules
import { createSelector } from 'reselect'

const telemedicineDashboard = (state) => state.dashboard.telemedicineDashboard

export const telemedicineBillingCodes$ = createSelector(
  telemedicineDashboard,
  ({ telemedicineBillingCodes = [] }) =>
    telemedicineBillingCodes.map((item, key) => ({
      ...item,
      key,
      title: `${item.code} - ${
        item.abbreviationDescription || item.description
      }`,
      value: item.uuid,
      children: item.children
        ? item.children.map((item, key) => ({
            ...item,
            key,
            title: `${item.code} - ${
              item.abbreviationDescription || item.description
            }`,
            value: item.uuid
          }))
        : []
    }))
)
